<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class IconVolumeHigh extends Vue {}
</script>

<template>
  <span class="volume-icon"><i class="fas fa-volume-up"/></span>
</template>

<style scoped lang="scss">
.volume-icon {
  font-size: 22px;
  margin-right: 10px;
}
</style>
